import { Component } from '@angular/core';
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {MatButtonModule} from "@angular/material/button";
import {TemplatingPreviewComponent} from "../../templating/templating-preview/templating-preview.component";
import {SessionPreviewComponent} from "../session-preview/session-preview.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {NgIf, Location} from "@angular/common";

@Component({
  selector: 'session-delete',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    MatButtonModule,
    TemplatingPreviewComponent,
    SessionPreviewComponent,
    ErrorPanelComponent,
    MatProgressBarModule,
    NgIf
  ],
  templateUrl: './session-delete.component.html'
})
export class SessionDeleteComponent {

  loading = false
  error: any

  constructor(
    readonly api: ApiService,
    readonly router: Router,
    readonly route: ActivatedRoute,
    readonly location: Location) {
  }

  confirmDelete() {
    const sessionId = this.route.snapshot.params['sessionId']
    this.loading = true
    this.error = null
    this.api.deleteSession(sessionId).subscribe({
      next: (r) => {
        this.loading = false
        this.router.navigate(['/sessions'])
          .catch((e) => console.error('Router error', e))
          .finally(() => {})
      },
      error: (err) => {
        this.error = err
        this.loading = false
      }
    })
  }
}
